export default __webpack_public_path__ + "static/media/runkeeper-persona.cd19b725.jpg";